import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import UpcomingDueCustomers from './UpcomingDueCustomers';
import InstallmentSummaryCards from './InstallmentSummaryCards';
import GreetingHeader from './GreetingHeader';
import { Lock, CheckCircle, XCircle, CalendarClock, AlertCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function OperationsExecutiveDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/api/dashboard/operations-executive-stats`, { withCredentials: true })
      .then(({ data }) => setStats(data))
      .catch(() => setStats({}))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-96 text-slate-400">Loading dashboard...</div>;

  const cards = [
    { title: 'Pending Lock/Unlock', value: stats?.pending_lock_requests || 0, icon: Lock, color: 'text-orange-500', testId: 'ops-stat-pending-lock' },
    { title: 'Approved Requests', value: stats?.approved_lock_requests || 0, icon: CheckCircle, color: 'text-emerald-500', testId: 'ops-stat-approved-lock' },
    { title: 'Rejected Requests', value: stats?.rejected_lock_requests || 0, icon: XCircle, color: 'text-red-500', testId: 'ops-stat-rejected-lock' },
    { title: 'Active Installments', value: stats?.active_installments || 0, icon: CalendarClock, color: 'text-emerald-500', testId: 'ops-stat-active' },
    { title: 'Defaulted Installments', value: stats?.defaulted_installments || 0, icon: AlertCircle, color: 'text-red-500', testId: 'ops-stat-defaulted' },
  ];

  return (
    <div className="space-y-6" data-testid="operations-executive-dashboard">
      <GreetingHeader
        testId="ops-greeting"
        fallbackName="Operations Officer"
        subtitle="Operations Dashboard · Handle lock/unlock approvals and monitor installment health"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c, i) => (
          <Card key={i} className="bg-slate-900 border-slate-800 hover:-translate-y-1 transition-transform" data-testid={c.testId}>
            <CardHeader className="flex flex-row items-center justify-between pb-2">
              <CardTitle className="text-sm font-medium text-slate-400">{c.title}</CardTitle>
              <c.icon className={`h-4 w-4 ${c.color}`} />
            </CardHeader>
            <CardContent><div className="text-2xl font-bold text-white">{c.value}</div></CardContent>
          </Card>
        ))}
      </div>
    <InstallmentSummaryCards />
      <UpcomingDueCustomers />

    </div>
  );
}
